import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AnalyticalToolsService } from './analytical-tools.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private files: File[] = [];
  private filePreviews: any[] = [];
  newheaderid: any;
  updatedData: any;
  allFilestoSend: File[] = [];
  constructor(
    private analyticalToolsService: AnalyticalToolsService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  setFiles(files: File[]): void {
    this.files = files;
  }

  setAllfillesToSend(files: File[]): void {
    this.allFilestoSend = files;
  }

  reset(): void {
    this.files = [];
    this.filePreviews = [];
    this.updatedData = [];
    this.allFilestoSend=[];
  }

  getFiles(): File[] {
    return this.files;
  }

  setFilePreviews(filePreviews: any[]): void {
    this.filePreviews = filePreviews;
  }

  getFilePreviews(): any[] {
    return this.filePreviews;
  }

  saveNCRFiles(headerID: number): Promise<void> {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('headerId', headerID.toString());
        if (this.allFilestoSend) {
            this.allFilestoSend.forEach((file) =>
                formData.append('file', file, file.name)
            );
        }
        this.spinner.show();
        this.analyticalToolsService
            .addAtfiles(formData)
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe(
                () => {
                    this.getAtfiles(headerID).then(() => resolve());
                    this.allFilestoSend = [];
                },
                (error: any) => {
                    this.toaster.error('Error', error.error.message);
                    reject(error);
                }
            );
    });
}

getAtfiles(headerID: number): Promise<void> {
  return new Promise((resolve, reject) => {
      const key = { HeaderId: headerID };
      this.spinner.show();
      this.analyticalToolsService.getATfiles(key)
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe(
              (listData: any) => {
                  this.updatedData = listData.aTFiles;
                  resolve();
              },
              (error: any) => {
                  this.toaster.error('Error', error.message); 
                  reject(error);
              }
          );
  });
}

  updateRecord() {
    return this.updatedData;
  }
  addSingleFile() {
    this.newheaderid = localStorage.getItem('headerId');
    return this.newheaderid;
  }
}
